import { render, staticRenderFns } from "./VoiceAssistant.vue?vue&type=template&id=75be4177&scoped=true"
import script from "./VoiceAssistant.vue?vue&type=script&lang=js"
export * from "./VoiceAssistant.vue?vue&type=script&lang=js"
import style0 from "./VoiceAssistant.vue?vue&type=style&index=0&id=75be4177&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75be4177",
  null
  
)

export default component.exports